// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__wrGfr","LogoDiv":"Header_LogoDiv__nRiSO","HeaderText":"Header_HeaderText__mKWrN"};